/**
 * Converts a whole number to a string with prefixed zero, if the number is < 10
 * @param {int || string} num - an int or a string representation of an int
 * @returns {string} - the number as a string with prefixed zero
 */
const prefixZero = (num) => (parseInt(num, 10) < 10 ? `0${num}` : `${num}`);

/**
 * Converts all string values on an object to lower case
 * @param {object} obj - an object containing keys with string values
 * @returns {object} - the updated object
 */
const stringValsToLowercase = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (typeof (obj[key]) === 'string') {
      obj[key] = obj[key].toLowerCase();
    }
  });

  return obj;
};

export { prefixZero, stringValsToLowercase }; // eslint-disable-line
